import CrumbTitle from '@/components/crumbTitle/CrumbTitle';
import { useComplaints } from '@/features/faq/complaints/hooks/useComplaints';
import { ComplaintsTable } from '@/features/faq/complaints/table';
import { Translation } from '@/hoslog-intl';
import { QuestionCircle } from '@/icons';
import { createFileRoute, SearchSchemaInput } from '@tanstack/react-router';
import { z } from 'zod';

const sortItemSchema = z.object({
  id: z.enum(['nickname', 'phoneNumber', 'subject', 'message', 'createdDate']),
  desc: z.boolean(),
});

const complaintsSearchSchema = z
  .object({
    sort: z
      .preprocess((val) => {
        if (typeof val === 'string') {
          try {
            return JSON.parse(val);
          } catch {
            return undefined;
          }
        }
        return val;
      }, z.array(sortItemSchema))
      .optional(),

    createdDate: z.string().optional(),
    q: z
      .any()
      .optional()
      .transform((val) => (val == null ? undefined : String(val))),

    page: z.coerce.number().positive().catch(0),
    fetch: z.coerce.number().positive().max(100).catch(10),
  })
  .passthrough();

export const Route = createFileRoute('/(app)/faq/complaints/')({
  loader: () => {
    return {
      crumb: <CrumbTitle id="faq.complaints.crumb" icon={QuestionCircle} />,
      title: <Translation id="faq.complaints.title" />,
    };
  },
  component: RouteComponent,
  validateSearch: (search: SearchSchemaInput) => complaintsSearchSchema.parse(search),
});

function RouteComponent() {
  const { complaints, pagination, loading } = useComplaints();
  return <ComplaintsTable data={complaints} pagination={pagination} loading={loading} />;
}
